import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@gx-design/modal';
import { trans } from '@pepita-i18n/babelfish';
import { Loader } from '../../components';
import { renderImageEditor } from 'imgeditor';

const styles = {
    modalImageEditor: 'modal-image-editor',
    editorContainer: 'modal-image-editor__container',
};

export const ImageEditor = ({ image, loading, mode, onSave, onClose, suggestedAspectRatio, ratio, title }) => {
    let closeEditor = () => {};

    const handleClose = () => {
        closeEditor();
        onClose && onClose();
    };

    const handleSave = ({ data }) => {
        onSave && onSave(data);
        closeEditor();
    };

    const editorRef = useCallback((node) => {
        if (node !== null) {
            closeEditor = renderImageEditor(node, {
                suggestedaspectratio: suggestedAspectRatio,
                ratio: ratio,
                onSave: handleSave,
                imgurl: image,
                mode: mode,
                translations: {
                    save: trans('label.save'),
                    restore: trans('label.restore'),
                    rotate: trans('label.rotate'),
                    adapt: trans('label.adapt'),
                    drag: trans('label.drag_to_reposition'),
                },
            });
        }
    }, []);

    return (
        <Modal
            size="large"
            isOpen={true}
            title={title}
            className={styles.modalImageEditor}
            bodyHeight="minHeight"
            onClose={handleClose}
        >
            <Fragment>
                <div className={styles.editorContainer} ref={editorRef} />
                <Loader loading={loading} fixedOverlay={false} centered={false} />
            </Fragment>
        </Modal>
    );
};

ImageEditor.propTypes = {
    image: PropTypes.string,
    loading: PropTypes.bool,
    mode: PropTypes.oneOf(['data', 'raw']),
    title: PropTypes.string,
    onSave: PropTypes.func,
    onClose: PropTypes.func,
    ratio: PropTypes.string,
    suggestedAspectRatio: PropTypes.string,
};

ImageEditor.defaultProps = {
    title: trans('label.edit_image'),
    loading: false,
    mode: 'data',
};
